import { FC, useMemo } from 'react';
import {
  NavigationItemKey,
  getNavigationItems,
  NavigationItem,
} from 'components/navigation/utils/libs';
import { useUser } from 'modules/user/userSelector';
import { useAccount } from 'modules/account/accountSelector';
import { useAppLayoutState } from 'components/appLayout/appLayoutState';
import { useInsightsContainer } from 'components/insights/context';
import RouteTabSwitcher from '../../../../components/shared/RouteTabSwitcher';

const ALLOWED_INSIGHTS_KEYS = [
  NavigationItemKey.InsightsPost,
  NavigationItemKey.InsightsPage,
] as const;

const AnalyticsViewSwitcher: FC = () => {
  const user = useUser();
  const account = useAccount();
  const { insightSelectedPageType } = useAppLayoutState();
  const { pages } = useInsightsContainer();

  const analyticsRoutes = useMemo(() => {
    const navigationItems = getNavigationItems({
      account,
      user,
      insightSelectedPageType,
    });

    const insightsNavItem = navigationItems.find(
      (item) => item.key === NavigationItemKey.Insights,
    );
    const insightsLiteNavItem = navigationItems.find(
      (item) => item.key === NavigationItemKey.InsightsLite,
    );

    const hasPages = pages.length > 0;
    const routes: NavigationItem[] = [];

    if (hasPages && insightsLiteNavItem) {
      routes.push(insightsLiteNavItem);
    }

    if (insightsNavItem?.items) {
      const filteredItems = insightsNavItem.items.filter((item) => {
        if (item.isDisabled) return false;
        if (!hasPages) {
          return (
            ALLOWED_INSIGHTS_KEYS as readonly NavigationItemKey[]
          ).includes(item.key);
        }
        return true;
      });
      routes.push(...filteredItems);
    }

    return routes;
  }, [account, user, insightSelectedPageType, pages]);

  return <RouteTabSwitcher routes={analyticsRoutes} />;
};

export default AnalyticsViewSwitcher;
